import { useMemo } from 'react';
import { Box, Card, Tag, Text, Title } from '@nimbus-ds/components';
import { dateFormat, Format } from 'commons/utils/date';
import { useGetNuvemChatPaymentSummaryQuery } from 'domains/Billing/Checkout/CheckoutApi';
import { useGetRecurrentPaymentConcepts } from 'domains/Billing/Checkout/hooks';
import { useFormatCurrency } from 'domains/Billing/hooks';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';

export default function NuvemchatExtraDetail() {
  const t = useTranslationBilling(
    'checkout.conceptDetailContent.nuvemchatExtraDetail',
  );

  const { recurrentPaymentForConcept } = useGetRecurrentPaymentConcepts();

  const recurrentPaymentActivated = useMemo(
    () => recurrentPaymentForConcept('app-nuvemchat-cost'),
    [recurrentPaymentForConcept],
  );

  const { data, isSuccess } = useGetNuvemChatPaymentSummaryQuery();
  const formatCurrency = useFormatCurrency();

  if (!isSuccess) return null;

  function Row({ children }) {
    return (
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="baseline"
      >
        {children}
      </Box>
    );
  }

  if (!isSuccess) {
    return null;
  }

  return (
    <Card>
      <Box display="flex" flexDirection="column" gap="3">
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Title as="h3">{t('title')}</Title>
          {recurrentPaymentActivated && (
            <Tag appearance="neutral">{t('recurrentPaymentTag')}</Tag>
          )}
        </Box>
        <Text>{t('description')}</Text>
        <Box display="flex" flexDirection="column" gap="2">
          {!!data?.costPerConversation && (
            <Row>
              <Text>{t('cost')}</Text>
              <Box display="inline-flex" flexDirection="row">
                <Text>{formatCurrency(data.costPerConversation)}</Text>
                <Text fontSize="caption" color="neutral-textDisabled">
                  {'/' + t('conversation')}
                </Text>
              </Box>
            </Row>
          )}
          {!!data?.nextPaymentDate && (
            <Row>
              <Text>{t('nextPayment')}</Text>
              <Text>
                {dateFormat(data.nextPaymentDate, Format.DD_MM_YY, 'UTC')}
              </Text>
            </Row>
          )}
        </Box>
      </Box>
    </Card>
  );
}
